/* eslint-disable eqeqeq */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  Input,
  Pagination,
} from "../../_metronic/_partials/controls";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import bsCustomFileInput from "bs-custom-file-input";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { FileInput } from "../../_metronic/_partials/controls";
import {
  deleteHomePageBanner,
  fetchHomePageBanners,
  updateStatusHomePageBanner,
  uploadHomeBanner,
} from "../../actions/homebanners";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import GlobalLoader from "../../common/loaders/LoadingBox";
import { API_ROOT } from "../../constant/config";
import { Button, Modal } from "react-bootstrap";
import { useSnackbar } from "notistack";
import { useRef } from "react";

const SUPPORTED_FORMATS = ["image/jpeg", "image/jpg", "image/png"];
function get_url_extension(url) {
  var re = /(?:\.([^.]+))?$/;
  return re.exec(url)[1];
}

const checkValidFile = (file) => {
  if (file && file.type !== undefined) {
    return SUPPORTED_FORMATS.includes(file.type);
  }

  switch (get_url_extension(file)) {
    case "jpg":
      return SUPPORTED_FORMATS.includes("image/jpeg");

    case "jepg":
      return SUPPORTED_FORMATS.includes("image/jpeg");

    case "png":
      return SUPPORTED_FORMATS.includes("image/png");

    default:
      break;
  }
};

const Schema = Yup.object().shape({
  banner_file: Yup.mixed()
    .required("Banner File required")
    .test("fileType", "Select a valid file type", (file) => {
      return checkValidFile(file);
    }),
  slug: Yup.mixed().required("Banner URL is requried"),
});

export default function HomeBanner() {
  useEffect(() => {
    bsCustomFileInput.init();
  }, []);

  const { homeBanners } = useSelector(
    (state) => ({
      homeBanners:
        state.banners &&
        state.banners.homePageBanners &&
        state.banners.homePageBanners.docs,
    }),
    shallowEqual
  );

  const { count } = useSelector(
    (state) => ({
      count:
        state.banners &&
        state.banners.homePageBanners &&
        state.banners.homePageBanners.totalDocs,
    }),
    shallowEqual
  );

  const [displayfileName, setDisplayFilename] = useState("No file choosen");

  const [bannerStatus, setbannerStatus] = useState({
    status: true,
  });

  const [initPagination, setinitPagination] = useState({
    pageNumber: 1,
    pageSize: 10,
  });

  const dispatch = useDispatch();

  const sizePerPageList = [
    { text: "10", value: 10 },
    { text: "25", value: 25 },
    { text: "50", value: 50 },
    { text: "100", value: 100 },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: count ? count : 0,
    sizePerPageList: sizePerPageList,
    sizePerPage: initPagination.pageSize,
    page: initPagination.pageNumber,
  };

  const updateStatus = async (data, id) => {
    await dispatch(updateStatusHomePageBanner(data, id)).then((res) => {
      dispatch(fetchHomePageBanners(initPagination));
    });
  };

  const [showPopup, setShowpopup] = useState(false);
  const [bannerID, setbannerID] = useState("");

  const closePopup = () => {
    setShowpopup(false);
    setbannerID("");
  };

  const [editbannerID, seteditbannerID] = useState("");
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    if (editbannerID && editbannerID !== "") {
      console.log("id", editbannerID);

      const singlebannerInfo = homeBanners?.filter((banner, index) => {
        return banner._id === editbannerID;
      })[0];

      setDisplayFilename(getFileName(singlebannerInfo?.banner_image));
      setFileName(singlebannerInfo?.banner_image);

      setImagePreview({
        preview: `${API_ROOT}uploads/banners/${singlebannerInfo?.banner_image}`,
        showPreview: singlebannerInfo?.banner_image ? true : false,
      });

      setbannerStatus((prevState) => {
        const newState = { ...prevState };
        for (const inputName in newState) {
          newState[inputName] = singlebannerInfo?.status;
        }
        return newState;
      });
    }
  }, [editbannerID, homeBanners]);

  const columnImage = (cellContent, row) => {
    return (
      <div className="d-flex align-items-center">
        <img
          src={`${API_ROOT}uploads/banners/${row.banner_image}`}
          alt="banner"
          height={80}
          width={180}
        />
      </div>
    );
  };

  const columnStatus = (cellContent, row) => {
    if (row.status) {
      return (
        <>
          <span className="switch switch-primary switch-sm">
            <label>
              <input
                type="checkbox"
                defaultChecked="checked"
                name="status"
                value="1"
                onClick={() => {
                  updateStatus({ status: false }, row._id);
                }}
              />
              <span></span>
            </label>
          </span>
        </>
      );
    } else {
      return (
        <>
          <span className="switch switch-secondary switch-sm">
            <label>
              <input
                type="checkbox"
                name="status"
                value="0"
                onClick={() => {
                  updateStatus({ status: true }, row._id);
                }}
              />
              <span></span>
            </label>
          </span>
        </>
      );
    }
  };

  const columnAction = (cellContent, row) => {
    return (
      <>
        {/* <a
          title="Edit Banner"
          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
          onClick={() => {
            seteditbannerID(row._id);
          }}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
              title="Edit Banner"
            />
          </span>
        </a> */}
        <a
          title="Delete Banner"
          className="btn btn-icon btn-light btn-hover-info btn-sm"
          onClick={() => {
            setShowpopup(true);
            setbannerID(row._id);
          }}
        >
          <span className="svg-icon svg-icon-md svg-icon-info">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
              title="Delete Banner"
            />
          </span>
        </a>
      </>
    );
  };

  const columns = [
    {
      dataField: "slug",
      text: "Banner URL",
      sort: false,
      style: { minWidth: "180px" },
    },
    {
      dataField: "banner_image",
      text: "Banner Image",
      sort: false,
      style: { minWidth: "100px" },
      formatter: columnImage,
    },
    {
      dataField: "status",
      text: "Status",
      sort: false,
      style: { minWidth: "100px" },
      formatter: columnStatus,
    },
    {
      dataField: "action",
      text: "Actions",
      classes: "text-right pr-0",
      headerClasses: "text-right pr-1",
      style: {
        minWidth: "100px",
      },
      formatter: columnAction,
    },
  ];

  const tableChange = () => {
    return (type, { page, sizePerPage, sortField, sortOrder, data }) => {
      const pageNumber = page || 1;
      setinitPagination((prev) =>
        type === "sort"
          ? { ...prev, sortOrder, sortField }
          : type === "pagination"
          ? { ...prev, pageNumber, pageSize: sizePerPage }
          : prev
      );
    };
  };

  const [loader, setLoader] = useState(false);

  useEffect(() => {
    async function getHomeBanners() {
      setLoader(true);
      await dispatch(fetchHomePageBanners(initPagination));
      setLoader(false);
    }
    getHomeBanners();
  }, [dispatch, initPagination]);

  const getFileName = (str) => {
    if (str.length > 30) {
      return str.substr(0, 30) + "..." + str.substr(-11);
    }
    return str;
  };

  const handleStatus = (e, setFieldValue) => {
    let elementName = e.target.name;

    setbannerStatus((prevState) => {
      const newState = { ...prevState };
      newState[elementName] = !prevState[elementName];
      setFieldValue(elementName, !prevState[elementName]);
      return newState;
    });
  };

  const [loading, setLoading] = useState(false);

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const { enqueueSnackbar } = useSnackbar();

  const deleteBanner = (id) => {
    // server request for deleting product by seleted ids
    enableLoading();
    dispatch(deleteHomePageBanner(id)).then(async (data) => {
      setShowpopup(false);

      await dispatch(fetchHomePageBanners(initPagination));

      await enqueueSnackbar("Banner deleted successfully", {
        variant: "success",
        autoHideDuration: 4500,
      });

      disableLoading();
    });
  };

  const [imagePreview, setImagePreview] = useState({
    preview: null,
    showPreview: false,
  });

  const onHandleChangeFile = (e, setFileState, errors) => {
    let myFiles = Array.from(e.target.files);
    setFileState("banner_file", myFiles[0]);
    setDisplayFilename(getFileName(myFiles[0].name));

    let valid = SUPPORTED_FORMATS.includes(
      myFiles && myFiles !== undefined && myFiles[0].type
    );

    setImagePreview({
      preview: URL.createObjectURL(myFiles[0]),
      showPreview: valid,
    });

    if (valid) {
      setFileState("banner_file", myFiles[0]);
    }
  };

  const [saveloader, setsaveloader] = useState(false);

  const saveBannerInfo = (values,resetForm) => {
    // eslint-disable-next-line no-unreachable
    setsaveloader(true);

    const formData = new FormData();
    formData.append("homebanner", values.banner_file);
    formData.append("status", values.status);
    formData.append("slug", values.slug);

    dispatch(uploadHomeBanner(formData)).then(async (data) => {
      if (data.payload.status) {
        if (data && data.payload) {
          await dispatch(fetchHomePageBanners(initPagination));

          await enqueueSnackbar(data.payload.message, {
            variant: "success",
            autoHideDuration: 1500,
          });

          setImagePreview({
            preview: null,
            showPreview: false,
          });
          setDisplayFilename("No file choosen");
          setbannerStatus({
            status: true,
          });
          setsaveloader(false);
          resetForm({})
        }
      } else {
        await enqueueSnackbar(data.payload.message, {
          variant: "error",
          autoHideDuration: 4500,
        });
        setsaveloader(false);
      }
    });
  };

  return (
    <>
      {/* {isLoading && <GlobalLoader />} */}
      <div className="container">
        <Card>
          <CardHeader title="Home Banners"></CardHeader>
          <CardBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                slug:'',
                banner_file: editbannerID && fileName !== "" ? fileName : "",
                status: true,
              }}
              validationSchema={Schema}
              onSubmit={async (values, { setErrors,resetForm }) => {
                await saveBannerInfo(values,resetForm);
                resetForm({})
              }}
            >
              {({
                handleSubmit,
                field,
                setFieldValue,
                values,
                handleChange,
                errors,
              }) => (
                <>
                  {/* {console.log(values)} */}
                  <Form className="form form-label-right">
                    <div className="form-group row mt-5">
                      <Field
                        name="slug"
                        component={Input}
                        placeholder="Banner URL"
                        label="Banner URL"
                      />
                    </div>
                    <div className="form-group row mt-5">
                      <Field
                        name="banner_file"
                        component={FileInput}
                        label="Banner File"
                        type="file"
                        value={undefined}
                        onChange={(e) => {
                          onHandleChangeFile(e, setFieldValue, errors);
                        }}
                        accept=".png,.jpg,.jpeg"
                        filename={getFileName(displayfileName)}
                        helpertext="true"
                      />
                      <div className="col-lg-3 col-xl-3">
                        {imagePreview.showPreview ? (
                          <div className="preview">
                            <img
                              src={imagePreview.preview}
                              alt="image_preview"
                              width={180}
                              height={80}
                            />
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="form-group row mt-5">
                      <label className="col-xl-3 col-lg-2 col-form-label text-right">
                        Status
                      </label>
                      <div className="col-lg-6 col-xl-6">
                        <div className="radio-inline mt-3">
                          <label className="radio">
                            <input
                              type="radio"
                              name="status"
                              onChange={(e) => {
                                handleStatus(e, setFieldValue);
                              }}
                              checked={bannerStatus["status"]}
                              readOnly
                            />
                            <span></span>
                            Active
                          </label>
                          <label className="radio">
                            <input
                              type="radio"
                              name="status"
                              onChange={(e) => {
                                handleStatus(e, setFieldValue);
                              }}
                              checked={!bannerStatus["status"]}
                              readOnly
                            />
                            <span></span>
                            Inactive
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mt-5">
                      <label className="col-xl-3 col-lg-2 col-form-label text-right"></label>
                      <div className="col-lg-6 col-xl-6">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          onSubmit={() => handleSubmit()}
                          disabled={saveloader}
                        >
                          Submit
                          {saveloader && (
                            <span className="ml-3 spinner px-2 spinner-white"></span>
                          )}
                        </button>
                      </div>
                    </div>
                  </Form>
                </>
              )}
            </Formik>
            <div className="mt-5">
              <PaginationProvider
                pagination={paginationFactory(paginationOptions)}
              >
                {({ paginationProps, paginationTableProps }) => {
                  return (
                    <Pagination paginationProps={paginationProps}>
                      <BootstrapTable
                        wrapperClasses="table-responsive "
                        classes="table table-head-custom table-vertical-center"
                        bootstrap4
                        bordered={false}
                        remote
                        keyField="_id"
                        columns={columns}
                        data={homeBanners === null ? [] : homeBanners}
                        onTableChange={tableChange()}
                        {...paginationTableProps}
                        noDataIndication={() =>
                          homeBanners === null ? (
                            ""
                          ) : (
                            <div className="no-data-indication">
                              No records found
                            </div>
                          )
                        }
                      ></BootstrapTable>
                      {loader && <GlobalLoader />}
                    </Pagination>
                  );
                }}
              </PaginationProvider>
            </div>
            <div>
              <Modal show={showPopup} onHide={() => closePopup()}>
                <Modal.Header closeButton>
                  <Modal.Title>Home Banner Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="mt-5">
                    {loading ? (
                      <span>Please wait, Home Banner is deleting...</span>
                    ) : (
                      "Are you sure you want to remove banner ?"
                    )}
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() => closePopup()}
                    className={`btn btn-light btn-md font-weight-bold text-uppercase text-center mr-2`}
                  >
                    Close
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => deleteBanner(bannerID)}
                    className={`btn btn-primary btn-md font-weight-bold text-uppercase text-center`}
                    disabled={loading ? true : false}
                  >
                    Delete
                    {loading && (
                      <span className="ml-3 spinner px-2 spinner-white"></span>
                    )}
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          </CardBody>
        </Card>
      </div>
    </>
  );
}
